/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Logo from "../../assets/img/logo.png";
import {LogIn} from "lucide-react";

export const LoginForm: React.FC = () => {

    const { login, responseErrorMessage, versionControl } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = async () => {
        await login(username, password);
    };

    const isFormValid = username && password;

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && isFormValid) {
            e.preventDefault(); 
            handleLogin();
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault(); 
        if (isFormValid) {
            handleLogin();
        }
    };

  return (
    <>  
        <div className="mx-auto" style={{width: "250px", margin: "200px"}}>
            <form onSubmit={handleSubmit}>
                <div className="d-flex justify-content-center w-100 gap-3 align-items-center" >	
                    <LogIn size={24} color="black" style={{marginTop: "2px"}} />
                    <a href="/">
                        <img src={Logo} style={{width: '200px', marginBottom: "-7px"}} />
                    </a>
                </div>
                <label className="form-check-label mt-3" htmlFor={username}>Username:</label>
                <input 
                    id="username"
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Username"
                    className="form-control form-control-md"
                    autoComplete="off"
                />
                <label className="form-check-label mt-3" htmlFor={password}>Password:</label>
                <input 
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    className="form-control form-control-md"
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                />
                <button 
                className="form-control form-control-md btn btn-danger mt-3" 
                onClick={handleLogin}
                disabled={!isFormValid}
                >
                    Login
                </button>

                <div className='d-flex flex-column justify-content-center align-items-center pt-5'>
                    <div style={{color: "#9c9a9a", width: "100%"}}><span>Backend Version: {versionControl?.pomVersion}</span></div>
                    <div style={{color: "#9c9a9a", width: "100%"}}><span>App Version: {process.env.REACT_APP_VERSION_CONTROL}</span></div>  
                    <div style={{color: "#9c9a9a", width: "100%"}}><span>Build Date: {versionControl?.buildDate}</span></div>
                    <div style={{color: "#9c9a9a", width: "100%"}}><span>Build Counter: {versionControl?.buildCounter}</span></div>   
                </div>
            </form>
        </div>
    
    </>
  );
};
